import { deleteTempleteFn } from './base/fetch-without-body-template-fn';

export const deleteTemplateFn = deleteTempleteFn;
